module.exports = __webpack_public_path__ + "static/media/quote_img.f8901ac1.svg";